import { AfterViewInit, Component, ElementRef, ViewChild, effect, input, output } from '@angular/core';
import { acceptCompletion } from "@codemirror/autocomplete";
import { indentWithTab } from "@codemirror/commands";
import { markdown, markdownLanguage } from '@codemirror/lang-markdown';
import { EditorState, Extension } from '@codemirror/state';
import { keymap, placeholder } from "@codemirror/view";
import { basicSetup, EditorView } from 'codemirror';
import { RouteShareService } from 'src/app/shared/services/route-share.service';

@Component({
  selector: 'app-codemirror-ai',
  imports: [],
  standalone: true,
  templateUrl: './codemirror-ai.component.html',
  styleUrl: './codemirror-ai.component.scss'
})
export class CodemirrorAiComponent implements AfterViewInit {
  public readonly placeholder = input<string>('');
  public readonly rows = input<number>(5);
  public readonly instruction = input.required<string>();
  // eslint-disable-next-line @angular-eslint/no-output-native
  public readonly finish = output<string>();
  @ViewChild('codemirror') protected codemirror!: ElementRef<HTMLDivElement>;
  protected editorView: EditorView | undefined;
  protected editorState: EditorState | undefined;
  public extensions: Extension[] = [];


  constructor(private rss: RouteShareService) {
    effect(() => {
      const instruction = this.instruction();
      if (this.editorView && this.editorState) {
        this.editorView.setState(EditorState.create({ doc: instruction, extensions: this.extensions }));
      }
    });
  }

  public ngAfterViewInit(): void {

    const editorElement = this.codemirror.nativeElement;
    //Erste Codezeile ist immer 30,39px hoch (Zeile -> 22,3906px + Space -> 8px)
    //Jede weitere Zeile fügt 22,3906px hinzu
    const heightToRows = 8 + this.rows() * 22.3906;
    this.extensions = [
      basicSetup,
      keymap.of([{ key: "Tab", run: acceptCompletion }, indentWithTab]),
      placeholder(this.placeholder()),
      markdown({ base: markdownLanguage }),
      EditorState.readOnly.of(!this.rss.userCanEditBotConfig()),
      EditorView.lineWrapping,
      EditorView.theme({
        ".cm-gutters": {
          backgroundColor: "#00A599",
          color: "#fff"
        },
        ".cm-activeLineGutter": {
          backgroundColor: "#99DBD6"
        },
        ".cm-content": {
          minHeight: heightToRows + "px"
        },
        ".cm-gutter": {
          minHeight: heightToRows + "px"
        },
        "&.cm-editor": {
          height: "100%"
        },
        ".cm-scroller": {
          overflow: "auto"
        }
      }),
      EditorView.domEventHandlers({
        focusout: () => { this.saveToolConfig(); },
        keydown: (e: KeyboardEvent) => {
          if ((e.metaKey || e.ctrlKey) && e.key === 's') {
            e.stopPropagation();
            e.preventDefault();
            this.saveToolConfig();
          }
        }
      })
    ];

    try {
      this.editorState = EditorState.create({
        doc: this.instruction(),
        extensions: this.extensions
      });
    } catch (e) {
      console.error(e);
    }
    this.editorView = new EditorView({
      state: this.editorState,
      parent: editorElement
    });
  }

  public saveToolConfig() {
    if (this.editorView) {
      const currentCode = this.editorView.state.doc.toString();
      if (this.instruction() !== currentCode) this.finish.emit(currentCode);
    }
  }
}
